var about =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(8);
	__webpack_require__(48);
	__webpack_require__(91);
	__webpack_require__(93);
	__webpack_require__(96);
	__webpack_require__(98);
	__webpack_require__(100);
	__webpack_require__(103);
	__webpack_require__(104);
	__webpack_require__(107);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(9);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(47)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./about.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./about.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, "*{margin:0;padding:0}.wrap_bs_au h2{font-size:36px}.wrap_bs_au input [type=text],.wrap_bs_au textarea{max-width:320px}.row{width:100%}.row--one-button{padding:5% 20% 0}@media screen and (min-width:48em){.row-not-mobile{display:block}}@media screen and (max-width:48em){.row-not-mobile{display:none}}.container-inside{max-width:1230px;margin:0 auto}.bs-container{background:url(" + __webpack_require__(11) + ") no-repeat;background-position:50% 70%;height:895px}.bs-container-overlay{width:100%;height:100%;background:rgba(38,99,113,.6)}h1.bs-au-text1-item1{margin-top:0;margin-bottom:0}.bs-au-text1{text-align:center}.bs-au-text1-item1{font-weight:700;font-size:36px;color:#fff;padding-top:100px}.bs-au-text1-item2{font-size:32px;color:#fff}.bs-au-text2{margin-top:390px;text-align:center}.bs-au-text2-block1{border:8px solid #fff;text-align:center;width:100%;max-width:782px;margin:0 auto;box-sizing:border-box;padding:23px 35px}.bs-au-text2-block1 p{color:#fff;margin-top:12px;margin-bottom:12px}.carusel1{height:140px;background:#f3f3f3}.bs-container2{background:url(" + __webpack_require__(12) + ") no-repeat;background-position:50% 50%;height:1028px}.bs-container2 .container{height:100%}.bs-container2-block2{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;margin-top:115px;font-size:14px}.briliant-overlay{background:url(" + __webpack_require__(13) + ") no-repeat 15% 15%,url(" + __webpack_require__(14) + ") no-repeat 79% 16%;width:100%;height:100%}.bs-container2-block1{text-align:center;padding-top:160px;padding-bottom:35px}.bs-container2-block2-column1,.bs-container2-block2-column2{-ms-flex-preferred-size:404px;flex-basis:404px}.bs-container2-block2-column1{text-align:right;box-sizing:border-box;padding-right:22px}.bs-container2__col1-item1,.bs-container2__col1-item2,.bs-container2__col1-item3{display:-ms-flexbox;display:flex;-ms-flex-wrap:no-wrap;flex-wrap:no-wrap;padding-bottom:40px;min-height:85px}.bs-container2__col1-item1-text{box-sizing:border-box}.bs-container2__col1-item1-text p{padding-top:15px}.bs-container2__col1-item1-img{box-sizing:border-box;padding-left:15px;padding-right:25px}.bs-container2__col2-item1,.bs-container2__col2-item2,.bs-container2__col2-item3{display:-ms-flexbox;display:flex;-ms-flex-wrap:no-wrap;flex-wrap:no-wrap;padding-bottom:40px;min-height:85px}.bs-container2__col2-item1-text{box-sizing:border-box}.bs-container2__col2-item1-text p{padding-top:15px}.bs-container2__col2-item1-img{box-sizing:border-box;padding-left:2px;padding-right:13px}.bs-container3-block1{text-align:center}.bs-container3-block2{display:-ms-flexbox;display:flex;margin-top:50px;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center}.bs-container3-block2-item{width:300px;height:300px;margin:10px;box-sizing:border-box;padding:27px 20px;font-size:14px;text-decoration:none;color:#000}.bs-container3-block2-item p{margin-top:10px}.bs-container3-block2-item strong{font-size:18px}.tov-category1{background:url(" + __webpack_require__(15) + ")}.tov-category2{background:url(" + __webpack_require__(16) + ")}.tov-category3{background:url(" + __webpack_require__(17) + ")}.tov-category4{background:url(" + __webpack_require__(18) + ")}.tov-category5{background:url(" + __webpack_require__(19) + ")}.tov-category6{background:url(" + __webpack_require__(20) + ")}.bs-container4-block1{padding-top:160px}.bs-comp,.bs-container4-block1{text-align:center;text-transform:uppercase}.bs-comp{padding-top:10px}.comp-overlay{background:url(" + __webpack_require__(21) + ") no-repeat 50% 50%;width:100%;height:576px;margin-top:75px}.bs-comp-block{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;padding-top:70px}.bs-comp-block-column1,.bs-comp-block-column2{-ms-flex-preferred-size:438px;flex-basis:438px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.bs-comp-block-column2{padding-right:25px}.bs-comp-block-item1,.bs-comp-block-item2,.bs-comp-block-item3{margin-bottom:30px;display:-ms-flexbox;display:flex;-ms-flex-wrap:no-wrap;flex-wrap:no-wrap;-ms-flex-pack:center;justify-content:center}.bs-comp-block-item1 p,.bs-comp-block-item2 p,.bs-comp-block-item3 p{text-transform:none;margin-top:10px}.bs-comp-block-item1 .bs-comp__item-text,.bs-comp-block-item2 .bs-comp__item-text,.bs-comp-block-item3 .bs-comp__item-text{text-align:right;box-sizing:border-box;padding-right:40px;-ms-flex-preferred-size:322px;flex-basis:322px}.bs-comp-block-item1 .bs-comp__item-img,.bs-comp-block-item2 .bs-comp__item-img,.bs-comp-block-item3 .bs-comp__item-img{box-sizing:border-box;-ms-flex-preferred-size:88px;flex-basis:88px;text-align:right;margin-left:10px;padding-right:10px}.comp-img1{height:60px;background:url(" + __webpack_require__(22) + ") no-repeat;background-position:0 auto}.comp-img2{height:60px;background:url(" + __webpack_require__(23) + ") no-repeat;background-position:0 auto}.comp-img3{height:60px;background:url(" + __webpack_require__(24) + ") no-repeat;background-position:0 auto}.bs-comp-block-item4,.bs-comp-block-item5,.bs-comp-block-item6{margin-bottom:30px;display:-ms-flexbox;display:flex;-ms-flex-wrap:no-wrap;flex-wrap:no-wrap;-ms-flex-pack:center;justify-content:center}.bs-comp-block-item4 p,.bs-comp-block-item5 p,.bs-comp-block-item6 p{text-transform:none;margin-top:10px}.bs-comp-block-item4 .bs-comp__item-text,.bs-comp-block-item5 .bs-comp__item-text,.bs-comp-block-item6 .bs-comp__item-text{text-align:left;box-sizing:border-box;padding-left:50px;padding-right:25px;-ms-flex-preferred-size:322px;flex-basis:322px}.bs-comp-block-item4 .bs-comp__item-img,.bs-comp-block-item5 .bs-comp__item-img,.bs-comp-block-item6 .bs-comp__item-img{box-sizing:border-box;-ms-flex-preferred-size:88px;flex-basis:88px;text-align:left}.comp-img4{height:60px;background:url(" + __webpack_require__(25) + ") no-repeat;background-position:0 auto}.comp-img5{height:60px;background:url(" + __webpack_require__(26) + ") no-repeat;background-position:0 auto}.comp-img6{height:60px;background:url(" + __webpack_require__(27) + ") no-repeat;background-position:0 auto}.bs-brends-block{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-top:70px;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:stretch;align-items:stretch}.bs-brends-block .bs-brends-block-item{width:180px;margin-top:10px;margin-bottom:40px;text-decoration:none}.bs-brends-block .bs-brends-block-item .bs-brends-block-item-img{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;box-sizing:border-box;height:88px;text-align:center}.bs-brends-block .bs-brends-block-item .bs-brends-block-item-img img{max-height:80%;max-width:100%}.bs-brends-block .bs-brends-block-item .bs-brends-block-item-text{text-align:center;font-size:16px}.bs-brends-block .bs-brends-block-item .bs-brends-block-item-text p{padding:5px;color:#000}.bs-brends-block-info{text-align:center}@media screen and (min-width:48em){.bs-brends-block-not-mobile{display:-ms-flexbox;display:flex}.bs-brends-block-mobile{display:none}.bs-brends-block .bs-brends-block-item{width:250px}}@media screen and (max-width:48em){.bs-brends-block-not-mobile{display:none}.bs-brends-block-mobile{display:block}}.bs-um-center{text-align:center;padding-top:10px;margin-top:80px;text-transform:uppercase}.bs-um-center p{text-transform:none}.bs-um-center .bs-um-center-block2{display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;padding-top:140px;margin-top:-140px;-ms-flex-pack:space-;justify-content:space-;padding-bottom:100px;-ms-flex-align:stretch;align-items:stretch;background:url(" + __webpack_require__(28) + ") no-repeat 0 0}.bs-um-center .bs-um-center-block2 .bs-um-center-block2-item-img{display:-ms-flexbox;display:flex;-ms-flex-preferred-size:50%;flex-basis:50%}.bs-um-center .bs-um-center-block2 .bs-um-center-block2-item-text{display:-ms-flexbox;display:flex;-ms-flex-preferred-size:584px;flex-basis:584px;text-align:left;margin-top:100px;box-sizing:border-box;padding-left:50px;-ms-flex-wrap:wrap;flex-wrap:wrap}.bs-um-center .bs-um-center-block2 li{background:transparent url(" + __webpack_require__(29) + ") no-repeat scroll 0 4px;line-height:normal;list-style:outside none none;padding-bottom:10px;padding-left:50px;padding-top:3px;font-size:14px}.bs-um-center .bs-um-center-block2 li p{margin-top:10px;font-size:14px}.bs-presence{background:url(" + __webpack_require__(30) + ") no-repeat;background-position:0 11%}.bs-presence .bs-presence-block1{text-align:center;font-size:42px;padding-top:140px}.bs-presence .bs-presence-map{padding:10px}.bs-presence .bs-presence-map img{width:100%;box-sizing:border-box}.bs-presence .bs-partners-block1{text-align:center;margin-top:140px}.bs-presence .bs-partners-block2{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.bs-presence .bs-partners-block2 .bs-partners-block2-item1{padding-top:130px}.bs-presence .bs-partners-block2 .bs-partners-block2-item1 ul{margin-top:85px;max-width:426px}.bs-presence .bs-partners-block2 .bs-partners-block2-item1 ul p{margin-top:5px}.bs-presence .bs-partners-block2 .bs-partners-block2-item1 ul li{line-height:normal;list-style:outside none none;padding-bottom:10px;padding-left:30px;padding-top:3px;font-size:14px}.bs-presence .bs-partners-block2 .bs-partners-block2-item1 ul li.img1{background:transparent url(" + __webpack_require__(31) + ") no-repeat scroll 0 4px}.bs-presence .bs-partners-block2 .bs-partners-block2-item1 ul li.img2{background:transparent url(" + __webpack_require__(32) + ") no-repeat scroll 0 4px}.bs-presence .bs-partners-block2 .bs-partners-block2-item1 ul li.img3{background:transparent url(" + __webpack_require__(33) + ") no-repeat scroll 0 4px}.bs-presence .bs-partners-block2 .bs-partners-block2-item1 ul li.img4{background:transparent url(" + __webpack_require__(34) + ") no-repeat scroll 0 4px}.bs-presence .bs-partners-block2 .bs-partners-block2-item1 ul li.img5{background:transparent url(" + __webpack_require__(35) + ") no-repeat scroll 0 4px}.bs-partners-block2-item2{font-size:0}.bs-otziv-block{height:244px;background:#fff;border-radius:20px}.bs-vopros-block1{text-align:center;padding-top:80px}.bs-vopros-block1 h2{font-size:28px;font-weight:500}.bs-vopros-block{margin-top:35px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap}.bs-vopros-block .bs-vopros-block-item{-ms-flex-preferred-size:382px;flex-basis:382px;margin:10px;padding-top:10px}.bs-vopros-block .bs-vopros-block-item .bs-input{width:353px;height:48px;background:#fff;border-radius:10px;border:1px solid #eee;margin-bottom:10px;box-sizing:border-box;padding:13px}.bs-vopros-block .bs-vopros-block-item .bs-input input{border:none}.bs-vopros-block .bs-vopros-block-item1{-ms-flex-preferred-size:382px;flex-basis:382px;margin:10px;padding-top:10px;box-sizing:border-box}.bs-vopros-block .bs-vopros-block-item1 textarea{box-sizing:border-box;padding:13px;border:1px solid #eee;border-radius:10px}.bs-vopros-block .bs-input-btn{-ms-flex-preferred-size:100%;flex-basis:100%;text-align:center;margin-top:10px}.bs-contakt .bs-contakt-block1{text-align:center;padding-top:80px}.bs-contakt .bs-contakt-block1 h2{font-size:28px;font-weight:500}.bs-contakt .bs-contakt-block2{margin-top:45px;margin-bottom:45px}.bs-um-center-block1-mobile{display:none}.bs-um-center-block1-not-mobile{display:block}@media screen and (min-width:767px) and (max-width:1280px){.bs-au-text1-item1{font-size:28px}.bs-au-text1-item2{font-size:24px}.bs-au-text2-block1{max-width:585px}.briliant-overlay{background:none}.bs-container2-block1{padding-bottom:35px;padding-top:60px;text-align:center}.bs-container2-block1 h2{font-size:28px;color:#408898;text-transform:uppercase}.bs-container2-block1 p{font-size:18px}.bs-container2{background:url(" + __webpack_require__(36) + ");background-position:50% 50%;height:992px}.bs-container2-block2{display:-ms-flexbox;display:flex;font-size:14px;-ms-flex-pack:end;justify-content:end;-ms-flex-wrap:wrap-reverse;flex-wrap:wrap-reverse;margin-top:45px;width:405px;float:right}.bs-container2__col2-item1,.bs-container2__col2-item2,.bs-container2__col2-item3{display:-ms-flexbox;display:flex;padding-bottom:20px}.bs-container2__col1-item1,.bs-container2__col1-item2,.bs-container2__col1-item3{display:-ms-flexbox;display:flex;-ms-flex-direction:row-reverse;flex-direction:row-reverse;padding-bottom:20px}.bs-container2__col1-item1 .bs-container2__col1-item1-text,.bs-container2__col1-item2 .bs-container2__col1-item1-text,.bs-container2__col1-item3 .bs-container2__col1-item1-text{box-sizing:border-box;text-align:left}.bs-container2__col1-item1 .bs-container2__col1-item1-img,.bs-container2__col1-item2 .bs-container2__col1-item1-img,.bs-container2__col1-item3 .bs-container2__col1-item1-img{box-sizing:border-box;padding-left:2px;padding-right:13px}.bs-comp{margin-top:-50px}.bs-comp-block1 h2{font-size:28px;color:#408898}.bs-comp-block1 p{text-transform:none}.comp-overlay{background:none;margin-top:60px;height:auto}.comp-overlay .bs-comp-block{padding-top:0;-ms-flex-pack:distribute;justify-content:space-around}.comp-overlay .comp-img1{height:60px;background:url(" + __webpack_require__(37) + ") no-repeat;background-position:0 auto}.comp-overlay .comp-img2{height:60px;background:url(" + __webpack_require__(38) + ") no-repeat;background-position:0 auto}.comp-overlay .comp-img3{height:60px;background:url(" + __webpack_require__(39) + ") no-repeat;background-position:0 auto}.comp-overlay .comp-img4{height:60px;background:url(" + __webpack_require__(40) + ") no-repeat;background-position:0 auto}.comp-overlay .comp-img5{height:60px;background:url(" + __webpack_require__(41) + ") no-repeat;background-position:0 auto}.comp-overlay .comp-img6{height:60px;background:url(" + __webpack_require__(42) + ") no-repeat;background-position:0 auto}.bs-comp-block-column1,.bs-comp-block-column2{-ms-flex-preferred-size:320px;flex-basis:320px}.bs-comp-block-column2{padding-right:0}.bs-comp-block-item1,.bs-comp-block-item2,.bs-comp-block-item3{-moz-box-pack:center;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;margin-bottom:30px;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.bs-comp-block-item1 .bs-comp__item-text,.bs-comp-block-item2 .bs-comp__item-text,.bs-comp-block-item3 .bs-comp__item-text{text-align:left;padding:0}.bs-comp-block-item4,.bs-comp-block-item5,.bs-comp-block-item6{-moz-box-pack:center;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;margin-bottom:30px}.bs-comp-block-item4 .bs-comp__item-text,.bs-comp-block-item5 .bs-comp__item-text,.bs-comp-block-item6 .bs-comp__item-text{padding:0}.bs-container3{margin-top:90px}.bs-container3 h2{font-size:28px;color:#408898;text-transform:uppercase}.bs-container3-block2{max-width:767px;margin:0 auto}.bs-container3-block2-item{width:233px;height:233px;background-size:cover;padding:19px 17px;margin:5px}.bs-container3-block2-item strong{font-size:13px}.bs-container3-block2-item p{font-size:11px}.bs-container4-block1{padding-top:60px}.bs-container4-block1 h2{font-size:28px;color:#408898;text-transform:uppercase;padding-bottom:24px}.bs-brends-block{-ms-flex-pack:distribute;justify-content:space-around;margin-top:50px;max-width:767px;margin:0 auto}.bs-brends-block-item{margin:10px 15px 40px}.bs-um-center .bs-um-center-block2{background:transparent url(" + __webpack_require__(43) + ");background-position:52% 0;padding-bottom:100px}.bs-partners-block1 h2,.bs-presence-block1 h2{font-size:28px;color:#408898}.bs-partners-block2-item1 img{display:none}.bs-partners-block2-item2 img{width:80%}.bs-partners-block2-item2{text-align:center}.bs-presence .bs-partners-block2 .bs-partners-block2-item1{padding-top:0}.bs-presence .bs-partners-block2 .bs-partners-block2-item1 ul{margin-left:20px}}@media screen and (min-width:0px) and (max-width:766px){.bs-um-center .bs-um-center-block2{background:none}.bs-container{background:transparent url(" + __webpack_require__(11) + ");background-position:50% 50%;background-size:cover;height:auto}.bs-au-text1-item1{font-size:14px;padding-top:25px}.bs-au-text1-item2{font-size:12px}.bs-au-text2{margin-top:80px;text-align:center}.bs-au-text2-block1{font-size:12px;border:none}.bs-container2-block1 h2{font-size:14px;color:#408898;text-transform:uppercase;font-weight:700;max-width:200px;margin:0 auto;padding-bottom:18px}.bs-container2-block1 p{font-size:14px}.bs-container2{background:transparent url(" + __webpack_require__(44) + ") no-repeat;background-position:50% 1%;height:auto}.briliant-overlay{background:none}.bs-container2-block1{padding-bottom:35px;padding-top:30px}.bs-container2-block2{display:-ms-flexbox;display:flex;font-size:14px;-ms-flex-pack:end;justify-content:end;-ms-flex-wrap:wrap-reverse;flex-wrap:wrap-reverse;margin-top:200px;float:none;box-sizing:border-box;padding-left:10px;padding-right:10px;font-size:12px}.bs-container2__col2-item1,.bs-container2__col2-item2,.bs-container2__col2-item3{display:-ms-flexbox;display:flex;padding-bottom:15px}.bs-container2__col1-item1,.bs-container2__col1-item2,.bs-container2__col1-item3{display:-ms-flexbox;display:flex;-ms-flex-direction:row-reverse;flex-direction:row-reverse;padding-bottom:15px}.bs-container2__col1-item1 .bs-container2__col1-item1-text,.bs-container2__col1-item2 .bs-container2__col1-item1-text,.bs-container2__col1-item3 .bs-container2__col1-item1-text{box-sizing:border-box;text-align:left}.bs-container2__col1-item1 .bs-container2__col1-item1-img,.bs-container2__col1-item2 .bs-container2__col1-item1-img,.bs-container2__col1-item3 .bs-container2__col1-item1-img{box-sizing:border-box;padding-left:2px;padding-right:13px}.bs-comp{margin-top:40px}.bs-comp-block1 h2{font-size:14px;color:#408898}.bs-comp-block1 p{font-size:14px;text-transform:none;box-sizing:border-box;padding:10px 24px}.comp-overlay{background:none;margin-top:40px}.bs-comp-block{padding-top:0;-ms-flex-pack:distribute;justify-content:space-around}.bs-comp-block .comp-img1{height:60px;background:url(" + __webpack_require__(37) + ") no-repeat;background-position:0 auto}.bs-comp-block .comp-img2{height:60px;background:url(" + __webpack_require__(38) + ") no-repeat;background-position:0 auto}.bs-comp-block .comp-img3{height:60px;background:url(" + __webpack_require__(39) + ") no-repeat;background-position:0 auto}.bs-comp-block .comp-img4{height:60px;background:url(" + __webpack_require__(40) + ") no-repeat;background-position:0 auto}.bs-comp-block .comp-img5{height:60px;background:url(" + __webpack_require__(41) + ") no-repeat;background-position:0 auto}.bs-comp-block .comp-img6{height:60px;background:url(" + __webpack_require__(42) + ") no-repeat;background-position:0 auto}.bs-comp-block{-ms-flex-pack:center;justify-content:center;-ms-flex-direction:column;flex-direction:column;padding-left:10px;padding-right:10px}.bs-comp-block-column1,.bs-comp-block-column2{-ms-flex-preferred-size:initial;flex-basis:auto}.bs-comp-block-column2{padding-right:0}.bs-comp-block-item1,.bs-comp-block-item2,.bs-comp-block-item3{-moz-box-pack:center;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;margin-bottom:30px;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.bs-comp-block-item1 .bs-comp__item-text,.bs-comp-block-item2 .bs-comp__item-text,.bs-comp-block-item3 .bs-comp__item-text{text-align:left;padding:0}.bs-comp-block-item4,.bs-comp-block-item5,.bs-comp-block-item6{-moz-box-pack:center;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;margin-bottom:30px}.bs-comp-block-item4 .bs-comp__item-text,.bs-comp-block-item5 .bs-comp__item-text,.bs-comp-block-item6 .bs-comp__item-text{padding:0}.bs-comp-block-item1 .bs-comp__item-img,.bs-comp-block-item2 .bs-comp__item-img,.bs-comp-block-item3 .bs-comp__item-img{margin-left:0}.bs-container3{margin-top:40px}.bs-container3-block1 h2{font-size:14px;color:#408898;text-transform:uppercase;font-weight:700;padding-bottom:5px}.bs-container3-block1 p,.bs-container3-block2-item strong{font-size:14px}.bs-container3-block2-item p{font-size:11px;max-width:198px}.bs-container3-block2-item{box-sizing:border-box;height:auto;margin:5px 10px;padding:22px 10px;width:100%}.tov-category1{background:url(" + __webpack_require__(45) + ") no-repeat;background-position:100% 100%;background-size:contain;background-color:#a8d7dc}.tov-category2{background:url(" + __webpack_require__(16) + ") no-repeat;background-position:100% 100%;background-size:contain;background-color:#a8d7dc}.tov-category3{background:url(" + __webpack_require__(17) + ") no-repeat;background-position:100% 100%;background-size:contain;background-color:#a8d7dc}.tov-category4{background:url(" + __webpack_require__(18) + ") no-repeat;background-position:100% 100%;background-size:contain;background-color:#a8d7dc}.tov-category5{background:url(" + __webpack_require__(19) + ") no-repeat;background-position:100% 100%;background-size:contain;background-color:#a8d7dc}.tov-category6{background:url(" + __webpack_require__(20) + ") no-repeat;background-position:100% 100%;background-size:contain;background-color:#a8d7dc}.bs-container4-block1{margin-top:50px;padding-top:0;text-transform:none}.bs-container4-block1 h2{font-size:14px;color:#408898;text-transform:uppercase}.bs-container4-block1 p{font-size:11px;box-sizing:border-box;padding:5px 10px;text-transform:none}.bs-brends-block{-ms-flex-pack:center;justify-content:center;margin-top:20px}.bs-brends-block-item{display:none}.bs-brends-block-item:first-child{display:block}.bs-brends-block-info{font-size:12px}.bs-um-center{margin-top:40px}.bs-um-center-block1-mobile{display:block;text-decoration:none}.bs-um-center-block1-not-mobile{display:none}.bs-um-center-block1 h2{font-size:14px;color:#408898}.bs-um-center-block1 p{font-size:14px;padding:5px 10px}.bs-um-center .bs-um-center-block2 .bs-um-center-block2-item-img{height:357px;-ms-flex-preferred-size:inherit;flex-basis:inherit;background:url(" + __webpack_require__(46) + ") no-repeat;background-position:50% 35%}.bs-um-center .bs-um-center-block2 .bs-um-center-block2-item-text{padding-left:20px;padding-right:10px}.bs-um-center .bs-um-center-block2{-ms-flex-direction:column;flex-direction:column}.bs-um-center .bs-um-center-block2-item-text ul li{font-size:12px}.bs-um-center .bs-um-center-block2 .bs-um-center-block2-item-text{margin-top:0}.bs-presence-block1,.bs-presence-map{display:none}.bs-presence .bs-partners-block1{margin-top:0}.bs-presence .bs-partners-block1 h2{font-size:14px;color:#408898;text-transform:uppercase;padding-left:10px;padding-right:10px}.bs-presence .bs-partners-block2{-ms-flex-wrap:wrap-reverse;flex-wrap:wrap-reverse;-ms-flex-direction:column;flex-direction:column;padding-left:20px;padding-right:10px}.bs-presence .bs-partners-block2 .bs-partners-block2-item1{padding-top:0}.bs-presence .bs-partners-block2 .bs-partners-block2-item1 ul{margin-top:0;max-width:320px}.bs-presence .bs-partners-block2-item1 img{display:none}.bs-presence .bs-partners-block2-item2{text-align:center}.bs-presence .bs-partners-block2-item2 img{width:60%}.bs-otziv{box-sizing:border-box;padding-left:10px;padding-right:10px}.bs-vopros-block .bs-vopros-block-item1,.bs-vopros-block .bs-vopros-block-item .bs-input{width:320px}}.sb-block-sert{margin-top:60px}.sb-block-sert h2{text-align:center}.sb-block-sert .sert-container{display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;box-sizing:border-box;margin-top:30px;-ms-flex-wrap:wrap;flex-wrap:wrap}.sb-block-sert .sert-container .sert-item{width:250px;margin-top:15px;margin-bottom:15px}.sb-block-sert .sert-container .sert-item img{width:100%}.bs-vopros-block .captcha-field-about{margin:0 auto;width:303px;margin-bottom:20px}.form__captcha-error.form__error-msg{color:red;margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-001.jpg";

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-002.png";

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-003.png";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-004.png";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-018-1.png";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-019.png";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-020.png";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-021.png";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-022.png";

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-023.png";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-024.png";

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-012.png";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-013.png";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-014.png";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-015.png";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-016.png";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-017.png";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-026.png";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-025.png";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-027.png";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-031.png";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-032.png";

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-033.png";

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-034.png";

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-035.png";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-038.png";

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-039.png";

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-040.png";

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-041.png";

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-042.png";

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-043.png";

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-044.png";

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-045.png";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-046.png";

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-018-2.jpg";

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/about/80243-047.png";

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(49);
	var debounce = __webpack_require__(52);
	__webpack_require__(53);
	
	var size = __webpack_require__(55);
	
	jQuery(function ($) {
	    function setSlickBenefits() {
	        $('.js-slick-benefits').each(function () {
	            var $benefitsSlider = $(this);
	
	            if (!$benefitsSlider.hasClass('slick-initialized')) {
	                $benefitsSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	                    slidesToShow: 4,
	                    adaptiveHeight: false,
	                    responsive: [{
	                        breakpoint: size.desktop,
	                        settings: { slidesToShow: 2 }
	                    }, {
	                        breakpoint: size.tablet,
	                        settings: { slidesToShow: 1 }
	                    }]
	                }));
	            }
	        });
	    }
	    setSlickBenefits();
	
	    debounce.setResizeDebounce(setSlickBenefits);
	});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(50);
	
	jQuery(function () {
	    module.exports.params = {
	        infinite: true,
	        adaptiveHeight: true,
	        slidesToScroll: 1,
	        speed: 400
	    };
	
	    module.exports.paramsCssAnim = {
	        cssEase: 'ease',
	        useTransform: true,
	        speed: 600
	    };
	});

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds. If `immediate` is passed, trigger the function on the
	    // leading edge, instead of the trailing.
	    debounce: function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this,
	                args = arguments;
	            var later = function later() {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    },
	
	    setResizeDebounce: function setResizeDebounce(func, wait, immediate) {
	        wait = wait || 250;
	        immediate = immediate || false;
	        var thisD = this;
	        var debouncedFunc = thisD.debounce(func, wait, immediate);
	        $(window).resize(debouncedFunc);
	    }
	};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$defineProperties = __webpack_require__(56)['default'];
	
	module.exports = _Object$defineProperties({}, {
	    defaultFontSize: {
	        get: function get() {
	            var defaultFontSize = parseInt($('html').css('font-size'));
	            if (isNaN(defaultFontSize)) defaultFontSize = 16;
	            return defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobile: {
	        get: function get() {
	            return 20 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobileBig: {
	        get: function get() {
	            return 28 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tablet: {
	        get: function get() {
	            return 48 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tabletBig: {
	        get: function get() {
	            return 60 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    desktop: {
	        get: function get() {
	            return 76.5 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    }
	});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(57), __esModule: true };

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(58);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperties: __webpack_require__(75) });


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var core = __webpack_require__(61);
	var ctx = __webpack_require__(62);
	var hide = __webpack_require__(64);
	var has = __webpack_require__(74);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(63);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var createDesc = __webpack_require__(73);
	module.exports = __webpack_require__(69) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var IE8_DOM_DEFINE = __webpack_require__(68);
	var toPrimitive = __webpack_require__(72);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(69) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(69) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(71)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	var document = __webpack_require__(60).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(67);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var anObject = __webpack_require__(66);
	var getKeys = __webpack_require__(76);
	
	module.exports = __webpack_require__(69) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(77);
	var enumBugKeys = __webpack_require__(90);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(74);
	var toIObject = __webpack_require__(78);
	var arrayIndexOf = __webpack_require__(82)(false);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(79);
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(80);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(78);
	var toLength = __webpack_require__(83);
	var toAbsoluteIndex = __webpack_require__(85);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(84);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(87)('keys');
	var uid = __webpack_require__(89);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(61);
	var global = __webpack_require__(60);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(88) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(49);
	__webpack_require__(94);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    $('.js-slick-reviews').each(function () {
	        var $reviewsSlider = $(this);
	
	        $reviewsSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 3,
	            adaptiveHeight: false,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: {
	                    slidesToShow: 2
	                }
	            }, {
	                breakpoint: size.tablet,
	                settings: {
	                    slidesToShow: 1
	                }
	            }]
	        }));
	    });
	});

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */,
/* 96 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */,
/* 98 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(49);
	__webpack_require__(101);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    $('.js-slick-brands').each(function () {
	        var $brandsSlider = $(this);
	
	        $brandsSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 5,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: { slidesToShow: 4 }
	            }, {
	                breakpoint: size.tabletBig,
	                settings: { slidesToShow: 3 }
	            }, {
	                breakpoint: size.tablet,
	                settings: { slidesToShow: 2 }
	            }, {
	                breakpoint: size.mobileBig,
	                settings: { slidesToShow: 1 }
	            }]
	        }));
	    });
	});

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */,
/* 103 */
/***/ (function(module, exports) {

	'use strict';
	
	jQuery(function ($) {
	    var certPopup = {
	        cert: {
	            html: ''
	        }
	    };
	
	    $(document).on('click', '.js-about-certificate', function (e) {
	        e.preventDefault();
	        var $this = $(this);
	        var targetFile = $this.data('image');
	        var imageHtml = $('<img/>', {
	            src: targetFile,
	            alt: targetFile
	        });
	
	        certPopup.cert.html = imageHtml[0].outerHTML;
	
	        $.prompt(certPopup, {
	            initialState: 'cert',
	            classes: { prompt: 'jqi--width-by-content' },
	            top: 10
	        });
	    });
	});

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(49);
	__webpack_require__(105);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    $('.js-slick-promos').each(function () {
	        var $promosSlider = $(this);
	
	        $promosSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 5,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: { slidesToShow: 4 }
	            }, {
	                breakpoint: size.tabletBig,
	                settings: { slidesToShow: 3 }
	            }, {
	                breakpoint: size.tablet,
	                settings: { slidesToShow: 2 }
	            }, {
	                breakpoint: size.mobileBig,
	                settings: { slidesToShow: 1 }
	            }]
	        }));
	    });
	});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */,
/* 107 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/about.41c2976eb564598135c4.js